
import { WEI_SHI_CONFIG } from '../config/Weishi';
import { PIAN_DUO_DUO_CONFIG } from '../config/PianDuoDuo';
import { TEN_VIDEO_CONFIG } from '../config/TenVideo';
import { createLauncherFactory } from './helper';


export class LauncherFactory {
  public static readonly createTenVideoLauncher = createLauncherFactory(TEN_VIDEO_CONFIG);
  public static readonly createPianDuoDuoLauncher = createLauncherFactory(PIAN_DUO_DUO_CONFIG);
  public static readonly createWeishiLauncher = createLauncherFactory(WEI_SHI_CONFIG);
}


